import {
  FederationManifest,
  initFederation,
} from "@softarc/native-federation-orchestrator";
import { EnvironmentConfig } from "./env.config";
import {
  useShimImportMap,
  consoleLogger,
  globalThisStorageEntry,
} from "@softarc/native-federation-orchestrator/options";

let showErrors = false;
Promise.all([
  fetch("./env.config.json").then(
    (resp) => resp.json() as Promise<EnvironmentConfig>,
  ),
  fetch("./federation.manifest.json").then(
    (resp) => resp.json() as Promise<FederationManifest>,
  ),
])
  .then(async ([env, manifest]) => {
    showErrors = !env.production;
    const nf = await initFederation(manifest, {
      ...useShimImportMap({ shimMode: true }),
      logger: consoleLogger,
      storage: globalThisStorageEntry,
      hostRemoteEntry: "./remoteEntry.json",
      logLevel: "debug",
      sse: false, //!env.production,
    });
    return import("./app/bootstrap").then((m) =>
      m.bootstrap(env, nf, manifest),
    );
  })
  .catch((err) => {
    console.error("Failed to load app!");
    if (showErrors) console.error(err);
  });
